import { render, staticRenderFns } from "./PostExplainModalNew.vue?vue&type=template&id=43dd0d9e&scoped=true"
import script from "./PostExplainModalNew.vue?vue&type=script&lang=js"
export * from "./PostExplainModalNew.vue?vue&type=script&lang=js"
import style0 from "./PostExplainModalNew.vue?vue&type=style&index=0&id=43dd0d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd0d9e",
  null
  
)

export default component.exports